import { Ref } from 'react';
import { useTranslation } from 'react-i18next';

type UseInputTextParams = {
  disabled?: boolean;
  icon?: string;
  iconAriaLabel?: string;
  onClickIcon?: (...args: unknown[]) => void;
  ref?: Ref<HTMLInputElement>;
  referer?: Ref<HTMLInputElement>;
};

function useInputText({ disabled, icon, iconAriaLabel, onClickIcon, ref, referer }: UseInputTextParams) {
  const { t } = useTranslation();

  const refInput = referer ?? ref;

  const getIconAriaLabel = (iconType: string): string => {
    const iconLabels: Record<string, string> = {
      visible: t('buttons:Show password'),
      'visible-off': t('buttons:Hide password'),
      search: t('buttons:Search'),
      clear: t('buttons:Clear field'),
      calendar: t('buttons:Open calendar'),
      eye: t('buttons:Show password'),
      'eye-off': t('buttons:Hide password'),
    };

    return iconLabels[iconType] || t('buttons:Click {{icon}} icon', { icon: iconType });
  };

  const getIconAriaLabelValue = icon ? (iconAriaLabel || getIconAriaLabel(icon)) : undefined;

  const isIconClickable = typeof onClickIcon === 'function' && !disabled;

  return {
    refInput,
    getIconAriaLabelValue,
    isIconClickable,
  };
}

export default useInputText;
